import { entries } from 'lodash';
import type { ColumnId } from '../../../../gql/graphql';

export const columnIdEntries = <T>(columnIdObject: Partial<Record<ColumnId, T>>): [ColumnId, T][] =>
  entries(columnIdObject) as [ColumnId, T][];
